import {BaseTerms} from "../../infrastructure/models/base-terms";

export class CompetitorPlayersStatsModuleTerms extends BaseTerms {
  WEB_PLAYER_CARD_POPUP_STATS_NOT_AVAILABLE = "Statistics are not available";
  WEB_PLAYER_CARD_POPUP_STATS_CLOSE = "Close";
  WEB_PLAYER_CARD_POPUP_TOP_STATS = "Top Stats";
  WEB_PLAYER_CARD_POPUP_ATTACKING = "Attacking";
  WEB_PLAYER_CARD_POPUP_DEFENDING = "Defending";
  WEB_POP_STATS_PLAYER_DETAILS_BUTTON = "Player Details";
  WEB_ATHLETE_GAMES_DETAILS = "Game Details";
  WEB_SHOT_CHARTS_ASSISTS_BY = "Assist By";
}
